import Home from 'assets/icons/Home.svg';
import Wallet from 'assets/icons/Wallet.svg';
import Transfer from 'assets/icons/Swap.svg';
import Time from 'assets/icons/Time Square.svg';
import Profile from 'assets/icons/Profile.svg';
import Plus from 'assets/icons/Plus.svg';
import Activity from 'assets/icons/Activity.svg';
import HomeFill from 'assets/icons/Home-fill.svg';
import WalletFill from 'assets/icons/Wallet-fill.svg';
import TransferFill from 'assets/icons/Swap-fill.svg';
import TimeFill from 'assets/icons/Time-fill.svg';
import ProfileFill from 'assets/icons/Profile-fill.svg';
import PlusFill from 'assets/icons/Plus-fill.svg';
import ActivityFill from 'assets/icons/Activity-fill.svg';
import Card from 'assets/icons/Card.svg';
import CardFill from 'assets/icons/Card-fill.svg';
import Password from 'assets/icons/Password.svg';
import PasswordFill from 'assets/icons/Password-fill.svg';
import Chat from 'assets/icons/Chat.svg';
import ChatFill from 'assets/icons/Chat-fill.svg';
import Shield from 'assets/icons/Shield.svg';
import Call from 'assets/icons/Call.svg';
import { PATH } from 'data/30pay.path';

export const sidebarData = [
    {
        label: 'پیشخوان',
        icon: Home,
        iconFill: HomeFill,
        key: PATH.dashboard,
    },
    {
        label: 'کیف پول',
        icon: Wallet,
        iconFill: WalletFill,
        key: PATH.wallet,
    },
    {
        label: 'معامله آسان',
        icon: Transfer,
        iconFill: TransferFill,
        key: PATH.trade,
    },
    {
        label: 'گزارشات',
        icon: Time,
        iconFill: TimeFill,
        key: PATH.reports,
    },
    {
        label: 'قیمت لحظه‌ای',
        icon: Activity,
        iconFill: ActivityFill,
        key: PATH.markets,
    },
    {
        label: 'حساب بانکی',
        icon: Card,
        iconFill: CardFill,
        key: PATH.cards,
    },
    {
        label: 'مدیریت حساب کاربری',
        icon: Profile,
        iconFill: ProfileFill,
        key: PATH.profile,
    },
    {
        label: 'امنیت',
        icon: Password,
        iconFill: PasswordFill,
        key: PATH.security,
    },
    {
        label: 'دعوت از دوستان',
        icon: Plus,
        iconFill: PlusFill,
        key: PATH.referral,
    },
    {
        label: 'تیکت',
        icon: Chat,
        iconFill: ChatFill,
        key: PATH.ticket,
    },
    {
        label: 'قوانین',
        icon: Shield,
        // iconFill: ChatFill,
        key: PATH.rules,
    },
    {
        label: 'تماس با ما',
        icon: Call,
        // iconFill: ChatFill,
        key: PATH.contact,
    },
];
